import { render, staticRenderFns } from "./ContasAReceberEdit.vue?vue&type=template&id=63bd8f70&scoped=true&"
import script from "./ContasAReceberEdit.vue?vue&type=script&lang=js&"
export * from "./ContasAReceberEdit.vue?vue&type=script&lang=js&"
import style0 from "./ContasAReceberEdit.vue?vue&type=style&index=0&id=63bd8f70&prod&scoped=true&lang=css&"
import style1 from "./ContasAReceberEdit.vue?vue&type=style&index=1&id=63bd8f70&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bd8f70",
  null
  
)

export default component.exports